export enum QUERY_KEYS {
  setProfiler = 'set-profiler',
}
